export const Switch = {
  baseStyle: {
    track: {
      bg: "sand.300",
      _checked: { bg: "leaf.500" },
      _focusVisible: { boxShadow: "outline" },
    },
    thumb: { bg: "white" },
    label: { fontWeight: 500, color: "text.primary" },
  },
  defaultProps: { colorScheme: "leaf" },
};
